/**
 * 使用范围
 * 车辆管理->竞价中/结标中,竞拍记录
 * */
import { createStore } from '@souche-f2e/muji';
import API from '@/services';
export default createStore({
    state: {
        OfferCeneList: [],
        gd: '',
        totalNumber: 0,
        pageIndex: 1,
        pageSize: 3,
        type: 2,
    },
    effects: {
        // desc 车辆管理-竞拍记录
        getOfferCeneListByGoodsId({ gd, pageIndex }, { state }) {
            const data = {
                id: gd,
                type: state.type,
                pageIndex,
                pageSize: state.pageSize,
            };
            API.auction.getOfferCeneListByGoodsId(data).then((res) => {
                if (res) {
                    this.SET_STATE({
                        OfferCeneList: res,
                        gd,
                        totalNumber: res.totalNumber,
                        pageIndex: res.currentIndex,
                    });
                }
            });
        },
        updateTable(page, { state }) {
            const param = {
                id: state.gd,
                type: state.type,
                pageIndex: page,
                pageSize: state.pageSize,
            };
            API.auction.getOfferCeneListByGoodsId(param)
                .then((res) => {
                this.SET_STATE({
                    OfferCeneList: res,
                    // pageIndex: res.currentIndex,
                    pageIndex: page,
                });
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload).forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
    },
});
